import { A11yModule } from '@angular/cdk/a11y';
import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { NgTemplateOutlet } from '@angular/common';
import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbComponent, ButtonComponent, IconComponent } from 'design-system';
import { Breadcrumb } from 'shared';

import { TopbarItem, TopBarVariant } from '../../types/topbar.types';

@Component({
  host: {
    class: 'grid-container',
    '[class]': '"topbar--" + variant()',
  },
  imports: [
    A11yModule,
    BreadcrumbComponent,
    ButtonComponent,
    CdkMenu,
    CdkMenuItem,
    IconComponent,
    NgTemplateOutlet,
    RouterLink,
  ],
  selector: 'dsrks-topbar',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './topbar.component.html',
})
export class TopBarComponent {
  public variant = input.required<TopBarVariant>();
  public breadcrumbs = input<Breadcrumb[]>();
  public leftItems = input<TopbarItem[]>([]);
  public rightItems = input<TopbarItem[]>([]);
  public showBreadcrumbsOnMobile = input(false);

  isMenuOpen = signal(false);

  closeMenu() {
    this.isMenuOpen.set(false);
  }

  closeMenuOnEsc(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeMenu();
    }
  }

  isSingleItem(items: TopbarItem[]): boolean {
    return items.filter((item) => !item.hide).length === 1;
  }

  toggleMenu() {
    this.isMenuOpen.update((isOpen) => !isOpen);
  }
}
